export enum ReportDetail {
    quart = 'projectManagement.chart.dpc-quart.detail',
    execute = 'projectManagement.chart.dpc-exec.detail',
    weekly = 'projectManagement.chart.weekly-report.detail',
    quartCreate = 'projectManagement.chart.dpc-quart.create',
    executeCreate = 'projectManagement.chart.dpc-exec.create',
    weeklyCreate = 'projectManagement.chart.weekly-report.create',
}
